'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';
const __endpoints = require('endpoints.service');

export default class ProductsList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'product_category',
				type: 'select',
				canAdd: true,
				required: true,
				reference: {
					key: 'name',
					list: '/product/product_categories',
				},
			},
		];
		this.settings = {
			name: 'ProductsList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			pageTitle: true,
			translationPath: 'SALE.PRODUCTS',
			canManipulate: () => validAccess(undefined, ['Global Sales Configuration']),
			endpoint: __endpoints.collection.product.products,
		};
		this.init();
		return this;
	}
}
